import React, { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    question: "Which branches are eligible for the internship?",
    answer:
      "Students from Mechanical, Electrical, Electronics (ETC), and IT branches can apply. We accept candidates from both diploma and degree programs.",
  },
  {
    question: "Will I receive a certificate after the internship?",
    answer:
      "Yes, all participants will be awarded a verifiable internship certificate upon successful completion of the program.",
  },
  {
    question: "Is the internship conducted online or offline?",
    answer:
      "We offer both modes. You can choose an online internship if you prefer remote learning, or opt for offline sessions if you’re located nearby.",
  },
  {
    question: "Are the projects hands-on and practical?",
    answer:
      "Yes. Our programs focus on real-world applications. You will work on domain-specific projects guided by experienced mentors.",
  },
  {
    question: "Is this a paid internship program?",
    answer:
      "Yes. This is a paid internship program that includes training resources, expert mentorship, certification, and project support.",
  },
  {
    question: "What is the duration of the internship?",
    answer:
      "Internship duration varies by module, typically ranging from 4 to 6 weeks. Flexible schedules are available to accommodate academic calendars.",
  },
];

const FaqColumn = ({ faqs, openIndex, setOpenIndex, startIndex }) => {
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="space-y-6">
      {faqs.map((faq, i) => {
        const globalIndex = startIndex + i;
        return (
          <div
            key={globalIndex}
            className="bg-white border border-gray-200 rounded-xl shadow-sm transition duration-200 hover:shadow-md"
          >
            <button
              onClick={() => toggleFAQ(globalIndex)}
              className="flex justify-between items-center w-full p-5 text-left text-gray-800 font-medium text-lg focus:outline-none"
            >
              <span>{faq.question}</span>
              <ChevronDown
                className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
                  openIndex === globalIndex ? "rotate-180" : ""
                }`}
              />
            </button>
            {openIndex === globalIndex && (
              <div className="px-5 pb-5 text-gray-600 text-base leading-relaxed">
                {faq.answer}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const faqWrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        faqWrapperRef.current &&
        !faqWrapperRef.current.contains(event.target)
      ) {
        setOpenIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const half = Math.ceil(faqs.length / 2);
  const leftFAQs = faqs.slice(0, half);
  const rightFAQs = faqs.slice(half);

  return (
    <section className="bg-gray-50 py-20 px-6 md:px-12" id="faq">
      <div className="max-w-6xl mx-auto" ref={faqWrapperRef}>
        <h2 className="text-4xl font-bold text-center text-gray-800 mb-12">
          Frequently Asked Questions ?
        </h2>

        <div className="grid gap-8 md:grid-cols-2">
          <FaqColumn
            faqs={leftFAQs}
            openIndex={openIndex}
            setOpenIndex={setOpenIndex}
            startIndex={0}
          />
          <FaqColumn
            faqs={rightFAQs}
            openIndex={openIndex}
            setOpenIndex={setOpenIndex}
            startIndex={half}
          />
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
